var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchivedPPt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25833_194021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2C0 1.43269 1.43269 0 3.2 0H13.6L24 10.4V28.8C24 30.5673 22.5673 32 20.8 32H3.2C1.43269 32 0 30.5673 0 28.8V3.2Z",
    fill: "url(#paint0_linear_25833_194021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4H24L13.6 0V8C13.6 9.32548 14.6745 10.4 16 10.4Z",
    fill: "#DCE2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2002 0.400391H13.4346L23.5996 10.5654V28.7998C23.5996 30.3462 22.3462 31.5996 20.7998 31.5996H3.2002C1.6538 31.5996 0.400391 30.3462 0.400391 28.7998V3.2002C0.400391 1.6538 1.6538 0.400391 3.2002 0.400391Z",
    stroke: "black",
    strokeOpacity: 0.06,
    strokeWidth: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31591 27.4004V20.8549H6.8983C7.39474 20.8549 7.81768 20.9498 8.16712 21.1394C8.51655 21.3269 8.78288 21.5879 8.96612 21.9224C9.15149 22.2548 9.24418 22.6383 9.24418 23.073C9.24418 23.5076 9.15043 23.8912 8.96293 24.2235C8.77543 24.5559 8.50376 24.8148 8.14794 25.0002C7.79425 25.1855 7.36598 25.2782 6.86314 25.2782H5.21719V24.1692H6.63942C6.90575 24.1692 7.12521 24.1234 7.2978 24.0318C7.47251 23.938 7.60249 23.8091 7.68771 23.6451C7.77507 23.4789 7.81875 23.2882 7.81875 23.073C7.81875 22.8556 7.77507 22.666 7.68771 22.5041C7.60249 22.34 7.47251 22.2132 7.2978 22.1238C7.12308 22.0321 6.90149 21.9863 6.63303 21.9863H5.69979V27.4004H4.31591ZM9.96306 27.4004V20.8549H12.5454C13.0419 20.8549 13.4648 20.9498 13.8143 21.1394C14.1637 21.3269 14.43 21.5879 14.6133 21.9224C14.7986 22.2548 14.8913 22.6383 14.8913 23.073C14.8913 23.5076 14.7976 23.8912 14.6101 24.2235C14.4226 24.5559 14.1509 24.8148 13.7951 25.0002C13.4414 25.1855 13.0131 25.2782 12.5103 25.2782H10.8643V24.1692H12.2866C12.5529 24.1692 12.7724 24.1234 12.9449 24.0318C13.1197 23.938 13.2496 23.8091 13.3349 23.6451C13.4222 23.4789 13.4659 23.2882 13.4659 23.073C13.4659 22.8556 13.4222 22.666 13.3349 22.5041C13.2496 22.34 13.1197 22.2132 12.9449 22.1238C12.7702 22.0321 12.5486 21.9863 12.2802 21.9863H11.3469V27.4004H9.96306ZM15.3609 21.9959V20.8549H20.7366V21.9959H18.7327V27.4004H17.3648V21.9959H15.3609Z",
    fill: "#344054"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25833_194021",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF1F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25833_194021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivedPPt);
export default __webpack_public_path__ + "static/media/archivedPPt.3f27e3b36b035fef422677b83963c61b.svg";
export { ForwardRef as ReactComponent };